import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import NotFound from "./pages/NotFound";
import AboutVastech from './pages/about-vastech';
import ElevatorSolutions from './pages/elevator-solutions';
import ProjectPortfolio from './pages/project-portfolio';
import Homepage from './pages/homepage';
import ContactConsultation from './pages/contact-consultation';
import ACMaintenanceServices from './pages/ac-maintenance-services';
import SmartHomeServices from './pages/smart-home-services';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Navigate to="/homepage" replace />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/about-vastech" element={<AboutVastech />} />
        <Route path="/elevator-solutions" element={<ElevatorSolutions />} />
        <Route path="/project-portfolio" element={<ProjectPortfolio />} />
        <Route path="/contact-consultation" element={<ContactConsultation />} />
        <Route path="/ac-maintenance-services" element={<ACMaintenanceServices />} />
        <Route path="/smart-home-services" element={<SmartHomeServices />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
